import preferences from 'Preferences';

export const PROCESS_MANAGEMENT_SIDEPANEL_NAMESPACE = 'PROCESS_MANAGEMENT_SIDEPANEL';
export const TYPE_FILTER_PREFERENCE = 'TYPE_FILTER_';

export function getTypeFilterPreference(): Array<string> | undefined {
  const preference = preferences.get(getTypeFilterPreferenceKey());
  // The workflow dashboard previously only allowed users to select a single type (which was stored as a string)
  // in the user preferences. We now allow users to select multiple types, so we need to handle the case where
  // the user is still using the old preference format.
  if (preference == null) {
    return undefined;
  } else if (typeof preference === 'string') {
    return [preference];
  }
  return preference;
}

export function setTypeFilterPreference(newType: Array<string>): void {
  preferences.set({
    [getTypeFilterPreferenceKey()]: newType,
  });
}

function getTypeFilterPreferenceKey(): string {
  return `${TYPE_FILTER_PREFERENCE}${PROCESS_MANAGEMENT_SIDEPANEL_NAMESPACE}`;
}
